import * as React from 'react';
import CircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress';
import { WithStyles } from '@mui/styles';
import withStyles from '@mui/styles/withStyles';
import cx from 'clsx';

import styles from './Loading.styles';

export interface LoadingProps extends WithStyles<typeof styles> {
  margin?: 'none' | 'small' | 'normal' | 'big';
  progressProps?: CircularProgressProps;
  absolute?: boolean;
}

const Loading: React.FunctionComponent<LoadingProps> = (props): JSX.Element => {
  const { classes, margin = 'none', progressProps, absolute } = props;

  return (
    <div className={cx(classes.root, classes[margin], { [classes.rootAbsolute]: absolute })}>
      <CircularProgress size={40} classes={{ svg: classes.svg }} {...progressProps} />
    </div>
  );
};

export default withStyles(styles)(Loading);
